import {useLocation, useOutletContext} from "react-router-dom";

import {usePermitApplicationForm} from "permitapplication/hooks";
import {FormCheckbox, FormContainer} from "base/form/components";
import {
    PermitApplicationTypesFormField,
    PermitApplicationDocFormFields,
    PermitForm,
} from "./form";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";

const PermitApplicationTypesAndDocStep = () => {
    const {permit, isStepEditable} = useOutletContext();
    const basePath = useLocation();

    const fileFields = [
        "application_doc",
        "personal_id_doc",
        "plot_ownership_doc",
        "plot_use_authorization",
        "tax_id_doc",
    ];

    const {handleFormSubmit} = usePermitApplicationForm(permit, basePath, fileFields);

    return (
        <PermitForm permit={permit} onSubmit={handleFormSubmit}>
            <Stack spacing={1}>
                <FormContainer>
                    <Grid container direction="row" spacing={1}>
                        <Grid item xs={8}>
                            <PermitApplicationTypesFormField
                                disabled={!isStepEditable}
                            />
                        </Grid>
                        <Grid item xs={4} container justifyContent="flex-end">
                            <FormCheckbox
                                name="is_the_plot_owner"
                                label="O titular é propriétario/a da parcela"
                                disabled={!isStepEditable}
                            />
                        </Grid>
                    </Grid>
                </FormContainer>
                <FormContainer>
                    <PermitApplicationDocFormFields disabled={!isStepEditable} />
                </FormContainer>
            </Stack>
        </PermitForm>
    );
};

export default PermitApplicationTypesAndDocStep;
